import { View } from "react-native";
import { useTheme, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import CuantoLogoDark from "./CuantoLogoDark";

export default function CuantoLoveFooter() {
  const tailwind = useTailwind();
  const { fonts } = useTheme();
  const variant = "labelLarge";

  return (
    <View style={tailwind("flex-row justify-center items-center")}>
      <Text variant={variant} style={tailwind("text-center mr-1.5")}>
        Creado con ❤️ usando
      </Text>
      <CuantoLogoDark height={fonts[variant].lineHeight} />
    </View>
  );
}
